import { getCookie, setCookie } from "../store/sessionStore";

const CryptoJS = require('crypto-js');

export const encryptText = (text) => {
   if(text !== undefined && text !== null) {
      return CryptoJS.AES.encrypt(text.toString(), process.env.REACT_APP_COOKIE_KEY).toString();
   }

   return "";
}

export const decryptText = (text) => {
   if(text !== undefined && text !== null) {
      return CryptoJS.AES.decrypt(text, process.env.REACT_APP_COOKIE_KEY).toString(CryptoJS.enc.Utf8);
   }

   return "";
}

export const resetOldCookies = () => {
   const organizationVal = parseInt(getCookie('organization'));
   if(Number.isInteger(organizationVal)) {
      setCookie('organization', encryptText(organizationVal));
   }
}